const _ServiceCode = {
  video: 'video',
  photo: 'photo',
  comic: 'comic',
  apparel: 'apparel',
  drive: 'drive',
  agnam: 'agnam',
  git: 'git',
  diary: 'diary',
  friend: 'friend',
  encode: 'encode',
  archive: 'archive',
  timeline: 'timeline',
  chat: 'chat',
  dutch: 'dutch',
} as const;

export type ServiceCode = (typeof _ServiceCode)[keyof typeof _ServiceCode];

export interface Service {
  code: ServiceCode;
  icon: string;
  title: string;
  documentTitle?: string;
  /** 로그인·권한 없이 링크로 쓰는 서비스(dutch). 권한 목록에 없어도 서비스 목록에 넣는다 */
  public?: boolean;
}

const services: Service[] = [
  {
    code: 'video',
    icon: 'fa-solid fa-film',
    title: 'Video',
    documentTitle: 'Hyunflix',
  },
  {
    code: 'photo',
    icon: 'fa-solid fa-camera',
    title: 'Photo',
  },
  {
    code: 'comic',
    icon: 'fa-solid fa-face-laugh-beam',
    title: 'Comic',
  },
  {
    code: 'apparel',
    icon: 'fa-solid fa-shirt',
    title: 'Apparel',
  },
  {
    code: 'drive',
    icon: 'fa-solid fa-hard-drive',
    title: 'Drive',
  },
  {
    code: 'agnam',
    icon: 'fa-solid fa-torii-gate',
    title: 'Agnam',
  },
  {
    code: 'git',
    icon: 'fa-brands fa-git-alt',
    title: 'Git',
  },
  {
    code: 'diary',
    icon: 'fa-solid fa-book',
    title: 'Diary',
  },
  {
    code: 'friend',
    icon: 'fa-solid fa-users',
    title: 'Friend',
  },
  {
    code: 'encode',
    icon: 'fa-solid fa-scissors',
    title: 'Encode',
  },
  {
    code: 'archive',
    icon: 'fa-solid fa-box-archive',
    title: 'Archive',
  },
  {
    code: 'timeline',
    icon: 'fa-solid fa-map-location-dot',
    title: 'Timeline',
  },
  {
    code: 'chat',
    icon: 'fa-solid fa-comments',
    title: 'Chat',
  },
  {
    code: 'dutch',
    icon: 'fa-solid fa-money-bill-transfer',
    title: 'Dutch',
    public: true,
  },
];

export default services;

function getService(code: ServiceCode): Service | undefined {
  return services.filter((v) => v.code === code)[0];
}

export function setDocumentTitle(title: string) {
  const code = window.location.hostname.split('.')[0].replace('local-', '') as ServiceCode;
  const service = getService(code);
  const documentTitle = service?.documentTitle ?? service?.title;
  const documentTitleSuffix = documentTitle ? ` - ${documentTitle}` : '';
  window.document.title = `${title}${documentTitleSuffix}`;
}

/** 지금 서비스의 브랜드 이름(HyunDiary, HyunGPT …). 호스트 이름에서 읽는다 */
export function serviceBrand(): string {
  const code = window.location.hostname.split('.')[0].replace('local-', '');
  if (code === 'chat') {
    return 'HyunGPT';
  }
  return `Hyun${code.charAt(0).toUpperCase()}${code.slice(1)}`;
}
